<template>
  <section>
      <v-container>
  <div v-html="html" style="margin-top:70px">
  </div>
    </v-container>
    </section>  
</template>


<script>
// comunicacion HTTP con RestApi
import api from "@/api";

export default {
  name: "PaginaCondicionesLegales",

  data: () => ({
    html: '',
    tipoPagina: 0
  }),

  // captura los cambios de parametros en la ruta si le llama esta pagina estando activa
  $route: function() {
    this.obtenerTerminosCondiciones();
    window.scrollTo(0,0);
  },
  

  methods: {
    obtenerTerminosCondiciones: function() {
      api.ObtenerCondicionesLegales(this.$route.params.tipoPagina)
      .then ((respuesta) => {
          this.html = respuesta.data.informacion.texto;
        })

      .catch(error => {
          console.log(error)
      })
      .finally(() => { 
      })        
    }  // fin ObtenerTerminosCondiciones

  },  // fin methods

  mounted () {
    // consulto al parking por el texto a presentar
    this.obtenerTerminosCondiciones();
    window.scrollTo(0,0);
  },
   // fin evento mounted  

};
</script>
